import { Component, inject, Signal } from '@angular/core';
import { TherapyPlanStateService } from '@therapist/shared/services/state/therapy-plan-state.service';
import { TherapyPlanDto } from '@therapist/shared/models/therapy-plan/therapy-plan.dto';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SekeletonLoadingComponent } from '@therapist/shared/components/sekeleton-loading/sekeleton-loading.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { TherapistClientDto } from '@therapist/shared/models/client/therapist-client.dto';
import { Button } from 'primeng/button';
import { TherapyPlanAdministrationApiService } from '@therapist/shared/services/api/therapy-plan-administration-api.service';
import { TherapyPlanStatusEnum } from '@therapist/shared/models/therapy-plan/therapy-plan-status.enum';
import { ExerciseTherapyPlanListComponent } from '../../components/exercise-therapy-plan-list-item/exercise-therapy-plan-list.component';
import { TherapyPlanProgressDto } from '@therapist/shared/models/therapy-plan/therapy-plan-progress.dto';
import { ProgressBar } from 'primeng/progressbar';

@Component({
  selector: 'sana-tp-therapy-plan-details-page',
  imports: [
    SekeletonLoadingComponent,
    ReactiveFormsModule,
    NgTemplateOutlet,
    DatePipe,
    RouterLink,
    ExerciseTherapyPlanListComponent,
    Button,
    ExerciseTherapyPlanListComponent,
    ProgressBar
  ],
  templateUrl: './therapy-plan-details-page.component.html',
  styleUrl: './therapy-plan-details-page.component.scss'
})
export class TherapyPlanDetailsPageComponent {

  readonly #clientStateService = inject(TherapistClientStateService);
  readonly #therapyPlanStateService = inject(TherapyPlanStateService);
  readonly #therapyPlanApiService = inject(TherapyPlanAdministrationApiService);

  selectedClient: Signal<TherapistClientDto | null> = this.#clientStateService.getSelectedClient();
  selectedTherapyPlan: Signal<TherapyPlanDto | null> = this.#therapyPlanStateService.getSelectedTherapyPlan();
  therapyPlanProgress: Signal<TherapyPlanProgressDto | null> = this.#therapyPlanStateService.getTherapyPlanProgress();

  isClientLoaded: Signal<boolean> = this.#clientStateService.getIsClientLoaded();
  isTherapyPlanLoaded: Signal<boolean> = this.#therapyPlanStateService.getIsTherapyPlanLoaded();

  updateTherapyPlanStatus(status: TherapyPlanStatusEnum): void {
    this.#therapyPlanApiService
      .updateTherapyPlanStatus(this.selectedTherapyPlan()!.id, status)
      .subscribe(data => this.#therapyPlanStateService.setSelectedTherapyPlan(data));
  }

  protected readonly TherapyPlanStatusEnum = TherapyPlanStatusEnum;
}
